import React, { Component } from 'react'
import { Card } from 'react-bootstrap';
import { Container, Typography, Grid, CardContent, CardActions, Button } from '@material-ui/core';
import { PostData } from '../../api/service';



export default class NotificationDescription extends Component {
    state = {
        allData: [],
        years: [],
        selectedYear: '',
        isLoaded: false
    }

    // Parse a "dd-mm-yyyy" string into a sortable timestamp.
    __toTime = (d) => {
        if (!d || typeof d !== 'string') return 0;
        const parts = d.split('-');
        if (parts.length === 3) {
            // dd-mm-yyyy
            return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`).getTime() || 0;
        }
        return new Date(d).getTime() || 0;
    }

    __loadFile = () => {
        let d = {
            dept_code: 'NSS',
            type: this.props.code
        }

        PostData(`/getnoticesbytypedept`, d)
            .then((resp) => {
                const all = Array.isArray(resp) ? resp : [];

                // Distinct years present in the data, latest first.
                const years = [...new Set(all.map((el) => String(el.year)).filter((y) => y && y !== 'undefined'))]
                    .sort((a, b) => Number(b) - Number(a));

                // Default to the year passed in (if it has data) else the latest year.
                const propYear = this.props.year ? String(this.props.year) : '';
                const selectedYear = years.includes(propYear) ? propYear : (years[0] || '');

                this.setState({
                    allData: all,
                    years,
                    selectedYear,
                    isLoaded: true
                })
            })
            .catch(() => {
                this.setState({ allData: [], years: [], selectedYear: '', isLoaded: true })
            })
    }

    componentDidMount() {
        this.__loadFile();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.code != this.props.code) {
            this.setState({ isLoaded: false }, () => this.__loadFile())
        }
    }

    selectYear = (year) => {
        this.setState({ selectedYear: year })
    }

    render() {
        const { years, selectedYear, allData, isLoaded } = this.state;

        // Only the selected year's notices, latest to oldest.
        const visible = allData
            .filter((el) => String(el.year) === String(selectedYear))
            .sort((a, b) => this.__toTime(b.date) - this.__toTime(a.date));

        return (
            <>
                <div style={{ minHeight: this.props.noMinHeight == true ? '' : '100vh' }}>
                    <Container>
                        <Typography variant="h5" style={{ marginTop: "1em", fontWeight: 700 }}>
                            {this.props.title}
                        </Typography>

                        <div style={{ backgroundColor: '#f9f5f9', display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginTop: '1em', padding: '8px 10px' }}>
                            <h6 style={{ margin: 0, marginRight: 10 }}>Browse by Year:</h6>
                            {years.length > 0 ? years.map((el) => (
                                <a
                                    key={el}
                                    onClick={() => this.selectYear(el)}
                                    style={{
                                        cursor: 'pointer',
                                        padding: '4px 14px',
                                        margin: '4px 6px',
                                        borderRadius: 4,
                                        fontWeight: 700,
                                        color: String(el) === String(selectedYear) ? 'white' : '#2054CD',
                                        backgroundColor: String(el) === String(selectedYear) ? '#2054CD' : '#e8eefc'
                                    }}
                                >
                                    {el}
                                </a>
                            )) : <span style={{ color: '#777' }}>No records</span>}
                        </div>

                        <br />

                        {isLoaded ? (
                            <Grid container spacing={2}>

                                {visible.map((el, index) =>

                                    <Grid item key={index} xs={12} sm={12} lg={12} md={12}>

                                        <Card style={{ boxShadow: 'none', backgroundColor: '#F3F3F3', border: 'solid 1px #B9B9B9' }}>


                                            <CardContent>
                                                <Typography
                                                    variant="caption"
                                                >
                                                    Posted on <strong>{el.date}</strong> by <span style={{ fontWeight: 700, color: "#2054CD" }}>{el.posted_as}</span>
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    gutterBottom
                                                >
                                                    {el.title}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    dangerouslySetInnerHTML={{ __html: el.description }}
                                                >
                                                </Typography>
                                            </CardContent>

                                            {Array.isArray(el.upload_info) ? (
                                                <CardActions>
                                                    {el.upload_info.map((el1, index1) =>
                                                        <Button
                                                            size="small"
                                                            key={index1}
                                                            color="primary"
                                                            style={{ border: 'solid 1px #B9B9B9' }}
                                                            target="_blank"
                                                            href={el1.url}

                                                        >
                                                            Attachment {index1 + 1}
                                                        </Button>
                                                    )}
                                                </CardActions>
                                            ) : null}

                                        </Card>
                                    </Grid>

                                )}

                                {visible.length === 0 ? (
                                    <Grid item xs={12}>
                                        <Typography>No {this.props.title}{selectedYear ? ` for ${selectedYear}` : ''}</Typography>
                                    </Grid>
                                ) : null}

                            </Grid>
                        ) : <Typography>Loading . . . </Typography>}

                        <br />
                        <br />
                    </Container>
                </div>
            </>
        )
    }
}
